const CommissionsTypes = {
    1: 'Promotor',
    2: 'Proveedor',
    3: 'Plataforma',
}

export default CommissionsTypes
